import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/mark/Documents/use-date-input-patch/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useRef } from "react";
import { Playground } from "docz";
import { ClickOutside } from "@use-date-input/popper";
import { Button } from "../../gatsby-theme-docz/components/Button";
import { ButtonBar } from "../../gatsby-theme-docz/components/ButtonBar";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "clickoutside"
    }}>{`ClickOutside`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`ClickOutside`}</inlineCode>{` component is used to detect when the mouse is clicked outside the calendar.`}</p>
    <p>{`In the default implementation `}<inlineCode parentName="p">{`ClickOutside`}</inlineCode>{` is used to determine when to close the `}<inlineCode parentName="p">{`Calendar`}</inlineCode>{` when rendered inside a `}<inlineCode parentName="p">{`Popper`}</inlineCode>{`.
Clicks within the `}<inlineCode parentName="p">{`Calender`}</inlineCode>{` or on the associated inputs should not close the `}<inlineCode parentName="p">{`Calendar`}</inlineCode>{` but everywhere else should.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`In this example when you click the buttons they log whether or not it considers it a click outside the rendered tree.
In addition an ignored list of refs can be provided which, when clicked, will not invoke `}<inlineCode parentName="p">{`onClickOutside`}</inlineCode>{`.`}</p>
    <Playground __position={0} __code={'() => {\n  const ignoreRef = useRef()\n  const ignoreListRefs = [ignoreRef]\n  function handleClickOutside() {\n    console.log(\'you clicked outside the component\')\n  }\n  return (\n    <>\n      <ButtonBar>\n        <Button>Click Outside</Button>\n        <Button ref={ignoreRef}>Click Outside (but in the allow list)</Button>\n      </ButtonBar>\n      <ClickOutside\n        onClickOutside={handleClickOutside}\n        ignoreClickOutsideRefs={ignoreListRefs}\n      >\n        <Button style={{ margin: \'8px\' }}>Click Inside</Button>\n      </ClickOutside>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useRef,
      Playground,
      ClickOutside,
      Button,
      ButtonBar,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const ignoreRef = useRef();
        const ignoreListRefs = [ignoreRef];

        function handleClickOutside() {
          console.log('you clicked outside the component');
        }

        return <>
            <ButtonBar mdxType="ButtonBar">
                <Button mdxType="Button">Click Outside</Button>
                <Button ref={ignoreRef} mdxType="Button">Click Outside (but in the allow list)</Button>
            </ButtonBar>
            <ClickOutside onClickOutside={handleClickOutside} ignoreClickOutsideRefs={ignoreListRefs} mdxType="ClickOutside">
                <Button style={{
              margin: "8px"
            }} mdxType="Button">Click Inside</Button>
            </ClickOutside>
        </>;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Prop Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Is Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`node`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`children to monitor for click outside events`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ignoreClickOutsideRefs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Additional array of refs, will ignore click outside from`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onClickOutside`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback called when the mouse is clicked outside`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      